import styled from "styled-components";

export const AudioBoxSC = styled.div`
  border-top: 1px solid var(--gray-dark);
  border-bottom-left-radius: var(--radius);
  border-bottom-right-radius: var(--radius);
  justify-content: center;
  align-items: center;
  min-height: 2.4em;
  font-size: 0.7em;
  display: flex;
  gap: 2em;
  padding: 1em;
  flex-direction: column;
`;
